<div class="req-toolbar">
  <app-search-bar
    [placeholder]="'requirements.searchPlaceholder' | translate"
    [value]="searchTerm()"
    (valueChange)="onSearchChange($event)"
  />

  <app-segmented-filter-control
    [items]="statusTabItems()"
    [value]="statusTab()"
    [ariaLabel]="'requirements.statusFilter' | translate"
    (valueChange)="onStatusTabChange($event)"
  />

  <app-filter-dropdown
    name="type"
    [value]="typeFilter() || ''"
    [placeholder]="'requirements.filter.allTypes' | translate"
    [options]="typeDropdownOptions()"
    (valueChange)="onTypeChange($event)"
  />

  <app-filter-dropdown
    name="priority"
    [value]="priorityFilter() || ''"
    [placeholder]="'requirements.filter.allPriorities' | translate"
    [options]="priorityDropdownOptions()"
    (valueChange)="onPriorityChange($event)"
  />

  <app-filter-dropdown
    name="author"
    [value]="authorFilter() || ''"
    [placeholder]="'requirements.filter.allAuthors' | translate"
    [options]="authorDropdownOptions()"
    (valueChange)="onAuthorChange($event)"
  />

  <app-filter-dropdown
    name="statusValue"
    [value]="statusValueFilter() || ''"
    [placeholder]="'requirements.filter.allStatusValues' | translate"
    [options]="statusValueDropdownOptions()"
    (valueChange)="onStatusValueChange($event)"
  />

  <app-saved-views-menu
    [views]="savedViews()"
    [activeName]="activeSavedView()"
    [context]="'REQUIREMENTS'"
    [projectId]="projectId()"
    (viewSelected)="onSavedViewSelected($event)"
    (viewSaved)="onSavedViewSaved($event)"
    (viewDeleted)="onSavedViewDeleted($event)"
    (viewDeleteFailed)="onSavedViewDeleteFailed($event)"
  />

  <span class="req-count">
    {{ resultCountKey() | translate: { count: paginatorLength(), total: tabCounts().total } }}
  </span>
</div>
